import { Model } from '@kaiser-software/chassis-core';

export class WorkLogModel extends Model {

    public seconds: number;

    public minutes: number;

    public hours: number;

    public createdAt: string;

    public updatedAt: string;

    public location: any;

    public account: any;

    public user: any;

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/work-logs/models/work-log.model.ts